export default "/local/templates/atc_1pdr/dist/images/icon-account.svg?867608283b5ff99d7fad338e7c4f0267";